import { render, staticRenderFns } from "./CustomerAdjust.vue?vue&type=template&id=2ccbf8b9&scoped=true"
import script from "./CustomerAdjust.vue?vue&type=script&lang=js"
export * from "./CustomerAdjust.vue?vue&type=script&lang=js"
import style0 from "./CustomerAdjust.vue?vue&type=style&index=0&id=2ccbf8b9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccbf8b9",
  null
  
)

export default component.exports